import { type FC, useEffect, useState } from 'react'

const CORRECT_PASSWORD = 'DD2025'
const PASSWORD_KEY = 'daydaco_password_verified'

interface PasswordProtectionProps {
  children: React.ReactNode
}

const PasswordProtection: FC<PasswordProtectionProps> = ({ children }) => {
  const [isVerified, setIsVerified] = useState(false)
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Check if password was already entered
    const verified = localStorage.getItem(PASSWORD_KEY)
    if (verified === 'true') {
      setIsVerified(true)
    }
    setIsLoading(false)
  }, [])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (password === CORRECT_PASSWORD) {
      localStorage.setItem(PASSWORD_KEY, 'true')
      setIsVerified(true)
      setError('')
    } else {
      setError('Incorrect password. Please try again.')
      setPassword('')
    }
  }

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
    if (error) setError('')
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-600">
          <i className="fa-duotone fa-solid fa-spinner-third fa-spin fa-3x" />
        </div>
      </div>
    )
  }

  if (isVerified) {
    return <>{children}</>
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <img
            className="mx-auto h-16 w-auto"
            src="/dd_logo.png"
            alt="Daydaco"
          />
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Enter Password
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Please enter the password to access the website
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="password" className="sr-only">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              className="appearance-none rounded-lg relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="Enter password"
              value={password}
              onChange={handlePasswordChange}
            />
          </div>

          {error && (
            <div className="text-red-600 text-sm text-center">{error}</div>
          )}

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-offset-gray-50 transition-colors"
            >
              Access Website
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PasswordProtection
